import { AfterViewInit, Component, ComponentFactoryResolver, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { ColaboradorEvaluacionModalComponent } from "@contenido/AppContent/global/colaboradorevaluacion/colaboradorevaluacion.component";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxDataGridComponent } from "devextreme-angular";


@Component(
    {
        selector: 'configuracion',
        templateUrl: './configuracion.component.html',
        styleUrls: ['./configuracion.component.scss']
    })

export class ConfiguracionComponent implements AfterViewInit{
    consulta!:boolean;
    listaperiodoevaluacion:any[];
    configuracion: any;
    dataTable:any[];
    maxDate: Date = new Date();
    minDate: Date = new Date();

    periodoevaluacion: number = 0;

    @ViewChild('colaborador') private colaborador!: ColaboradorEvaluacionModalComponent;

    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

        this.listaperiodoevaluacion = [];
        this.dataTable = [];
    }

    ngAfterViewInit(){
        this.Periodoevaluacion();
    }

    Correo(entidad:any){
        this.grid.instance.saveEditData();
        this.configuracion = entidad;
        this.colaborador.seleccionMultiple = true;
        this.colaborador.nivel = entidad.nivel;
        this.colaborador.grado = entidad.grado;
        this.colaborador.grupo = entidad.grupo;
        let fecha = new Date();
        let dia = fecha.getDate();
        let mes = fecha.getMonth()+1;
        let year = fecha.getFullYear();
        let stringfecha = dia+"/"+mes+"/"+year;
        this.colaborador.fechaaplicacion = stringfecha;
        this.colaborador.Modal();

    }

    Periodoevaluacion(){
        this.appService.Post("evaluacionpendiente/configuracion/periodoevaluacion",{listatipoevaluacion:[3,4], listanivel:[1,2]}).then(res =>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.listaperiodoevaluacion = res.data;
            }
        })
    }

    preescolaryprimaria(id:number){
        if(id){
            this.appService.Post("evaluacionpendiente/configuracion/buscar",{"periodoevaluacionid":id}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.dataTable = res.data;
                }
            })
        }else{
            this.dataTable = [];
        }
    }

    formatDate(date: string) {
        let valor = date.split("/")
        let fecha = valor[2] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    logEvent(e:any){
        if(e.column.index == 3){
            this.minDate = new Date(this.formatDate(e.data.fechainicioevaluacion)+ "T00:00:00");
            this.maxDate = new Date(this.formatDate(e.data.fechainicioacuerdos)+ "T00:00:00");
            this.grid.onEditorPreparing.subscribe((e:any) =>{
                if(e.index === 3 && e.name === "fechaaplicacion"){
                    e.editorOptions.max = this.maxDate;
                    e.editorOptions.min = this.minDate;
                }
            });
            
        }
    }

    generarruta(datos:any){
        let token = "evaluacionexterno/emai/"+datos.nivelid+"-"+datos.gradoid+"-"+datos.grupoid+"-"+datos.periodoevaluacionid
        let ruta = datos.urlinicial+token;
        return ruta;
    }

    Guardar(entidad:any){
    this.appService.Post("evaluacionpendiente/configuracion",{"listacolaborador":entidad, "configuracion":this.configuracion}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.mensajeService.Alerta(AlertaEnum.Success, res.message);
            this.colaborador.CerrarModal();
            this.preescolaryprimaria(this.configuracion.periodoevaluacionid);
        }
    })
    }
}